import { render } from "./MealSet.vue?vue&type=template&id=4809868a"
import script from "./MealSet.vue?vue&type=script&lang=js"
export * from "./MealSet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__